module.exports = __webpack_public_path__ + "static/img/successRegister.1122b23.png";